import { type Tag, Tags } from "./schemas/tag";

/**
Search utility to compare a string against a search term.

It checks for the term inclusion ignoring casing in the user's locale.

This appears to be the default of what Web Awesome provides.
 */
export function stringMatches(value: string, term: string) {
  return value.toLocaleLowerCase().includes(term.toLocaleLowerCase());
}

/**
Search utility that dispatches to {@link stringMatches} on tag name.
*/
export function tagMatches(value: Tag, term: string) {
  return stringMatches(value.name, term);
}

/**
Search utility the dispatches to {@link tagMatches} for each element
and returns true as soon as there is a match.
*/
export function tagsMatches(value: Tags, term: string) {
  return value.some((v) => tagMatches(v, term));
}

/**
Global search function to be used in grid components.

Just like the default provided one, it uses case insensitive inclusion to
determine a match ("YAT" matches the term "t").
Unlike the default provided one, it can also treat known Work Monster types
that are used as grid column values.

TODO: support dates. At the time of this writing, dates are returned as
UTC strings and formatted into the user's locale. This search attempts to
match against the UTC string version. We should change that.
*/
export function gridSearch(
  value: unknown,
  term: string,
  _row: Record<string, unknown>,
) {
  if (value == null) {
    return false;
  }

  if (typeof value === "string") {
    return stringMatches(value, term);
  }

  if (Tags.is(value)) {
    return tagsMatches(value, term);
  }

  return false;
}
